/* This file is autogenerated, see readme.md for instructions */
import ChevronLeftSvgIcon from '@bloomreach/banana-theme/icons/chevron-left.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ChevronLeftIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ChevronLeftSvgIcon />
    </Icon>
  );
});

ChevronLeftIcon.displayName = 'ChevronLeftIcon';

export default ChevronLeftIcon;
